import EastIcon from "@mui/icons-material/East";

import {
  Box,
  Button,
  FormControl,
  IconButton,
  InputAdornment,
  Modal,
  OutlinedInput,
} from "@mui/material";
import axios from "axios";
import React, { useState } from "react";
import ScrollAnimation from "react-animate-on-scroll";
import { toast } from "react-toastify";
import Elements from "../assets/elements.png";
import Facebook from "../assets/facebook.png";
import instagram from "../assets/instagram.png";
import LicenseDraft from "../assets/licenseDraft.png";
import Linkdin from "../assets/linkdin.png";
import Newsletter from "../assets/newsLetter.gif";
import Podcast from "../assets/podcast.gif";
import Sources from "../assets/sources.gif";
import Subscriber from "../assets/Subscriber.png";
import vector from "../assets/vector.png";
import Whatsapp from "../assets/whatsapp.png";
import X from "../assets/x.png";
import appstore from "../store/appstore";
import Navbar from "./navbar";

const HomePage = () => {
  const [isMobileview, setIsMobileView] = useState(false);
  const [subscribeModal, setSubscribeModal] = useState(false);
  const [showConfit, setShowConfict] = useState(false);
  const { isSubscribed, setSubscribeEmail } = appstore();
  const [email, setEmail] = useState("");
  const handleSubscribe = async () => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!regex.test(email)) {
      toast.error("Please enter valid email");
      return;
    }
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: "https://simulyst.com/backend/subscribers",
      headers: {
        "Content-Type": "application/json",
      },
      data: { email: email, page: "landing-page" },
    };
    try {
      const response = await axios.request(config);
      // setMostPlayed(response.data);

      localStorage.setItem("isSubscribed", email);
      setSubscribeEmail(true);
      toast.success("Subscribed !", { autoClose: 2000 });
      setSubscribeModal(false);
      setShowConfict(true);
      setTimeout(() => {
        setShowConfict(false);
      }, 2000);
    } catch (error) {
      toast.error("Something went wrong!");
    }
  };
  React.useEffect(() => {
    if (isSubscribed) {
      setShowConfict(false);
    }
    if (window && window.innerWidth) {
      if (window.innerWidth < 930) {
        setIsMobileView(true);
      } else {
        setIsMobileView(false);
      }
    }
    const updateScreenWidth = () => {
      if (window.innerWidth < 930) {
        setIsMobileView(true);
      } else {
        setIsMobileView(false);
      }
    };
    window.addEventListener("resize", updateScreenWidth);
    return () => {
      window.removeEventListener("resize", updateScreenWidth);
    };
  }, []);
  return (
    <>
      {" "}
      <Navbar />
      <div>
        {/* <div className="demo"></div> */}

        <Box
          fontSize={isMobileview ? "28px" : "70px"}
          fontWeight={500}
          margin={"auto"}
          marginTop={"30px"}
          textAlign={"center"}
        >
          CURATED HEALTHCARE INSIGHTS,
        </Box>
        <Box
          fontSize={isMobileview ? "28px" : "70px"}
          fontWeight={500}
          margin={"auto"}
          textAlign={"center"}
          color={"#C789E4"}
        >
          DELIVERED WEEKLY
        </Box>
        <img
          src={vector}
          width={isMobileview ? "40%" : "18%"}
          style={{ margin: "auto", marginLeft: isMobileview ? "32%" : "46%" }}
        />
        <Box
          fontSize={isMobileview ? "16px" : "28px"}
          // fontWeight={500}
          width={"80%"}
          margin={"auto"}
          textAlign={"center"}
          color={isMobileview ? "#615E64" : "#9F9BA1"}
          marginTop={"15px"}
        >
          Serving you with freshly brewed weekly healthcare research, insights,
          and trends through our newsletters and on-the-go podcast style audio
          notes.
        </Box>
        <Box
          style={{
            margin: "auto",
            marginTop: isMobileview ? "-40px" : "-30px",
            fontWeight: "500",
            color: "#C789E4",
          }}
          fontSize={isMobileview ? "28px" : "40px"}
          textAlign={"center"}
          className="rotating-text-wrapper"
        >
          <Box> Newsletter</Box>
          <Box> Podcast</Box>
          <Box> Sources</Box>
        </Box>
        <Box
          style={{
            margin: "auto",
            // marginTop: "50px",
            fontWeight: "500",
            color: "#C789E4",
          }}
          fontSize={"28px"}
          textAlign={"center"}
          className="rotating-image-wrapper"
          position={"relative"}
        >
          <img
            className="rotating-image"
            src={Newsletter}
            style={{ width: "127px", height: "71px", opacity: 0.2 }}
          />
          <img
            className="rotating-image"
            src={Podcast}
            style={{ width: "85px", marginLeft: "21px", height: "81px" }}
          />
          <img
            className="rotating-image"
            src={Sources}
            style={{ width: "85px", marginLeft: "21px", height: "81px" }}
          />
        </Box>
        <Box
          style={{ display: "flex", justifyContent: "center" }}
          flexDirection={"column"}
          alignItems={"center"}
        >
          {!isSubscribed ? (
            <>
              {" "}
              <Box
                style={{
                  display: isMobileview ? "block" : "none",
                  fontSize: "12px",
                  marginTop: "25px",
                }}
              >
                To Explore our platform for free
              </Box>
              <Button
                variant="contained"
                style={{
                  margin: "auto",
                  marginTop: isMobileview ? "5px" : "25px",
                  fontWeight: "500",
                  // color: "#C789E4",
                  fontSize: isMobileview ? "" : "18px",
                  width: isMobileview ? "" : "336px",
                  height: isMobileview ? "" : "56px",
                }}
                onClick={() => {
                  setSubscribeModal(true);
                }}
              >
                {" "}
                Subscribe
              </Button>
            </>
          ) : (
            ""
          )}
        </Box>
        <ScrollAnimation animateIn="fadeInUp" delay={0.2 * 1000}>
          <Box>
            <Box
              width={isMobileview ? "90%" : "65%"}
              position={"relative"}
              // className="demo"
              margin={"auto"}
              // position={"relative"}
              // border={"1px solid red"}
              // width={'925px'}
              // border={"1px solid red"}
              bgcolor={"#F7F5FF"}
              padding={isMobileview ? "5px" : "18px"}
              marginTop={isMobileview ? "70px" : "150px"}
              paddingBottom={"20px"}
            >
              <span className="top"></span>
              <span className="right"></span>
              <span className="left"></span>
              <span className="bottom"></span>
              <Box
                fontSize={isMobileview ? "18px" : "48px"}
                display="flex"
                justifyContent="center"
                gap={isMobileview ? "10px" : "20px"}
                fontWeight={500}
                color={"#C789E4"}
                lineHeight={isMobileview ? "" : "30.861px"}
                height={isMobileview ? "" : "75px"}
                alignContent={"center"}
                marginTop={"10px"}
                alignItems={"center"}
              >
                100k+ human reviewed
                <Box
                  borderRadius={isMobileview ? "0px 9.541px" : "0px 26px"}
                  height={isMobileview ? "" : "75px"}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background: "#C789E4",
                    color: "white",
                    width: isMobileview ? "105px" : "287px",
                    textAlign: "center",
                  }}
                >
                  ARTICLES
                </Box>
              </Box>
              <Box
                fontSize={isMobileview ? "12px" : "28px"}
                width={"96%"}
                margin={"auto"}
                marginTop={isMobileview ? "10px" : "15px"}
                lineHeight={isMobileview ? "" : "30.861px"}
                // height={'auto'}
                // line-height: ; /* 110.217% */
              >
                Our platform offers users access to a growing collection of over
                100,000 healthcare-related articles
              </Box>
              <Box
                fontSize={isMobileview ? "12px" : "28px"}
                width={"96%"}
                margin={"auto"}
                marginTop={isMobileview ? "2px" : "8px"}
                lineHeight={isMobileview ? "" : "30.861px"}
              >
                Simulyst with AI research companion on every actions makes the
                platform extremely user friendly
              </Box>
            </Box>
          </Box>
        </ScrollAnimation>
        <Box
          display={"flex"}
          justifyContent={isMobileview ? "space-around" : "center"}
          marginTop={isMobileview ? "50px" : "150px"}
          gap={isMobileview ? "0px" : "50px"}
        >
          <ScrollAnimation
            animateIn="fadeInLeft"
            style={{
              width: "36%",
              marginRight: isMobileview ? "0px" : "50px",
            }}
          >
            {" "}
            <Box
              className="flip-container"
              position={"relative"}
              borderRadius={"12px"}
              width={"100%"}
              height={isMobileview ? "230px" : "230px"}
              // border={isMobileview ? "1.5px solid #dcdcdc" : "3px solid #dcdcdc"}
              fontSize={"14px"}
              padding={isMobileview ? "15px" : "30px"}
              // className="flip-container"
            >
              <Box
                borderRadius={"12px"}
                // width={"100%"}
                border={
                  isMobileview ? "1.5px solid #dcdcdc" : "3px solid #dcdcdc"
                }
                fontSize={"14px"}
                padding={isMobileview ? "15px" : "30px"}
                className="flip-container-front"
              >
                <img
                  src={LicenseDraft}
                  width={isMobileview ? "24px" : "38px"}
                  height={isMobileview ? "24px" : "38px"}
                  style={{ marginTop: "10px" }}
                />
                <Box
                  marginTop={"10px"}
                  fontSize={isMobileview ? "16px" : "38px"}
                  fontWeight={"600"}
                >
                  Newsletter
                </Box>
                <Box
                  style={{
                    position: "relative", // Ensure it doesn't merge with upper elements
                    fontWeight: isMobileview ? 500 : 400,
                    marginTop: "10px",
                    display: "-webkit-box",
                    width: "89%",
                    fontSize: isMobileview ? "14px" : "26px",
                    WebkitBoxOrient: "vertical",
                    WebkitLineClamp: isMobileview ? 6 : 2, // Limit to 2 lines
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                  color={isMobileview ? "#615E64" : "black"}
                >
                  Stay updated with the latest in healthcare! Our carefully
                  curated newsletter brings you the most recent articles,
                  research, and updates to support your research journey
                </Box>
                <Box
                  color={"#AE8EC1"}
                  fontSize={isMobileview ? "12px" : "16px"}
                  marginTop={"20px"}
                >
                  Read more
                </Box>
              </Box>

              <Box
                borderRadius={"12px"}
                // width={"40%"}
                border={
                  isMobileview ? "1.5px solid #dcdcdc" : "3px solid #dcdcdc"
                }
                height={"230px"}
                // borderRadius={"12px"}
                // width={"100%"}
                // border={"1.5px solid grey"}
                fontSize={"14px"}
                padding={isMobileview ? "15px" : "30px"}
                className="flip-container-back"
              >
                <img
                  src={LicenseDraft}
                  width={isMobileview ? "24px" : "38px"}
                  height={isMobileview ? "24px" : "38px"}
                  style={{ marginTop: "2px" }}
                />

                <Box
                  style={{
                    position: "relative", // Ensure it doesn't merge with upper elements
                    fontWeight: isMobileview ? 500 : 400,
                    // marginTop: "10px",
                    display: "-webkit-box",
                    // width: "89%",
                    fontSize: isMobileview ? "14px" : "26px",
                    WebkitBoxOrient: "vertical",
                    // WebkitLineClamp: isMobileview ? 6 : 2, // Limit to 2 lines
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                  color={isMobileview ? "#615E64" : "black"}
                >
                  Stay updated with the latest in healthcare! Our carefully
                  curated newsletter brings you the most recent articles,
                  research, and updates to support your research journey
                </Box>
                {/* <Box
                color={"#AE8EC1"}
                fontSize={isMobileview ? "12px" : "16px"}
                marginTop={"20px"}
              >
                Read more
              </Box> */}
              </Box>
            </Box>
          </ScrollAnimation>
          <ScrollAnimation
            animateIn="fadeInRight"
            style={{
              width: "36%",
              marginRight: isMobileview ? "25px" : "30px",
            }}
          >
            <Box
              className="flip-container"
              position={"relative"}
              borderRadius={"12px"}
              width={"100%"}
              height={isMobileview ? "230px" : "230px"}
              // border={isMobileview ? "1.5px solid #dcdcdc" : "3px solid #dcdcdc"}
              fontSize={"14px"}
              padding={isMobileview ? "15px" : "30px"}
            >
              <Box
                borderRadius={"12px"}
                // width={"100%"}
                border={
                  isMobileview ? "1.5px solid #dcdcdc" : "3px solid #dcdcdc"
                }
                fontSize={"14px"}
                padding={isMobileview ? "15px" : "30px"}
                className="flip-container-front"
              >
                <img
                  src={Elements}
                  width={isMobileview ? "24px" : "38px"}
                  height={isMobileview ? "24px" : "38px"}
                  style={{ marginTop: "10px" }}
                />
                <Box
                  marginTop={"10px"}
                  fontSize={isMobileview ? "16px" : "38px"}
                  fontWeight={"600"}
                >
                  Podcast
                </Box>
                <Box
                  style={{
                    position: "relative", // Ensure it doesn't merge with upper elements
                    fontWeight: isMobileview ? 500 : 400,
                    marginTop: "10px",
                    display: "-webkit-box",
                    width: "89%",
                    fontSize: isMobileview ? "14px" : "26px",
                    WebkitBoxOrient: "vertical",
                    WebkitLineClamp: isMobileview ? 6 : 2, // Limit to 2 lines
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                  color={isMobileview ? "#615E64" : "black"}
                >
                  Transform your research into audio! Simply upload any article
                  or study and listen wherever you are. Keep yourself informed
                  with our distinctive podcast feature—making healthcare
                  knowledge portable and easy to access
                </Box>
                <Box
                  color={"#AE8EC1"}
                  fontSize={isMobileview ? "12px" : "16px"}
                  marginTop={"20px"}
                >
                  Read more
                </Box>
              </Box>

              <Box
                borderRadius={"12px"}
                // width={"40%"}
                border={
                  isMobileview ? "1.5px solid #dcdcdc" : "3px solid #dcdcdc"
                }
                height={"230px"}
                // borderRadius={"12px"}
                // width={"100%"}
                // border={"1.5px solid grey"}
                fontSize={"14px"}
                padding={isMobileview ? "15px" : "30px"}
                className="flip-container-back"
              >
                <img
                  src={Elements}
                  width={isMobileview ? "24px" : "38px"}
                  height={isMobileview ? "24px" : "38px"}
                  style={{ marginTop: "-5px" }}
                />

                <Box
                  style={{
                    position: "relative", // Ensure it doesn't merge with upper elements
                    fontWeight: isMobileview ? 500 : 400,
                    marginTop: "0px",
                    display: "-webkit-box",
                    width: "100%",
                    fontSize: isMobileview ? "14px" : "26px",
                    WebkitBoxOrient: "vertical",
                    // WebkitLineClamp: isMobileview ? 6 : 7, // Limit to 2 lines
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    lineHeight: "normal",
                  }}
                  color={isMobileview ? "#615E64" : "black"}
                >
                  Transform your research into audio! Simply upload any article
                  or study and listen wherever you are. Keep yourself informed
                  with our distinctive podcast feature—making healthcare
                  knowledge portable and easy to access
                </Box>
              </Box>
            </Box>
          </ScrollAnimation>
        </Box>
        <Box
          display={"flex"}
          justifyContent={"center"}
          flexDirection={"column"}
          alignItems={"center"}
          marginTop={isMobileview ? "50px" : "150px"}
          marginBottom={isMobileview ? "20px" : "80px"}
        >
          <Box
            style={{
              fontSize: isMobileview ? "18px" : "30px",
              fontWeight: "700",
              textAlign: "center",
              margin: "auto",
              // border: "1px solid red",
              display: "flex",
              alignItems: "center",
            }}
          >
            Follow{" "}
            <p style={{ color: "#C789E4", marginLeft: "5px" }}> @SIMULYST</p>
          </Box>
          <Box
            display={"flex"}
            gap={isMobileview ? "12px" : "24px"}
            // marginTop={"8px"}
          >
            <img
              onClick={() => {
                window
                  .open("https://www.instagram.com/simulystofficial/", "_blank")
                  .focus();
              }}
              src={instagram}
              style={{ cursor: "pointer" }}
              width={isMobileview ? "24px" : "36px"}
              height={isMobileview ? "24px" : "36px"}
            />
            <img
              onClick={() => {
                window
                  .open(
                    `https://www.whatsapp.com/channel/0029VaxefWW4dTnSYetkZp3H`
                  )
                  .focus();
              }}
              src={Whatsapp}
              style={{ cursor: "pointer" }}
              width={isMobileview ? "24px" : "36px"}
              height={isMobileview ? "24px" : "36px"}
            />
            <img
              style={{ cursor: "pointer" }}
              onClick={() => {
                window
                  .open(
                    "https://www.facebook.com/share/12Grrt2rxi1/?mibextid=wwXIfr",
                    "_blank"
                  )
                  .focus();
              }}
              src={Facebook}
              width={isMobileview ? "24px" : "36px"}
              height={isMobileview ? "24px" : "36px"}
            />
            {/* <img
              onClick={() => {
                window
                  .open("https://www.instagram.com/simulystofficial/", "_blank")
                  .focus();
              }}
              src={Twitter}
              style={{ cursor: "pointer" }}
              width={isMobileview ? "24px" : "36px"}
              height={isMobileview ? "24px" : "36px"}
            /> */}
            <img
              src={X}
              onClick={() => {
                window.open("https://x.com/simulyofficial", "_blank").focus();
              }}
              style={{ cursor: "pointer" }}
              width={isMobileview ? "24px" : "36px"}
              height={isMobileview ? "24px" : "36px"}
            />
            <img
              src={Linkdin}
              onClick={() => {
                window
                  .open(
                    "https://www.linkedin.com/showcase/simulyst/?viewAsMember=true ",
                    "_blank"
                  )
                  .focus();
              }}
              style={{ cursor: "pointer" }}
              width={isMobileview ? "24px" : "36px"}
              height={isMobileview ? "24px" : "36px"}
            />
          </Box>
        </Box>
        <Modal
          open={subscribeModal}
          onClose={() => {
            setSubscribeModal(false);
          }}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: isMobileview ? "80%" : "32%",
              bgcolor: "background.paper",
              p: isMobileview ? 2 : 4,
              display: "flex",
              flexDirection: "column",
              gap: "6px",
              borderRadius: isMobileview ? "10px" : "20px",
            }}
          >
            <img src={Subscriber} width={"80%"} style={{ margin: "auto" }} />
            <Box
              margin={"auto"}
              fontSize={isMobileview ? "16px" : "22px"}
              fontWeight={600}
            >
              {" "}
              Join over 7304+ medical professionals unlocking valuable research
              insights with{" "}
            </Box>
            <Box
              margin={"auto"}
              fontSize={isMobileview ? "16px" : "22px"}
              fontWeight={600}
              color={"#C789E4"}
            >
              {" "}
              Simulyst
            </Box>
            <FormControl
              sx={{
                m: 1,
                marginTop: "15px",
                marginBottom: "15px",
                margin: "auto",
                width: "30ch",
              }}
              variant="outlined"
            >
              <OutlinedInput
                type={"text"}
                placeholder="Email ID"
                style={{
                  width: "100%",
                  borderRadius: "35px",
                  background: "#EDEDED",
                  border: "none",
                }}
                onKeyUp={(e) => {
                  if (e.key == "Enter") {
                    handleSubscribe();
                  }
                }}
                onChange={(e) => {
                  setEmail(e.target.value);
                }}
                focused={false}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label={"display the password"}
                      style={{ background: "#C789E4", color: "white" }}
                      onClick={() => {
                        handleSubscribe();
                      }}
                      edge="end"
                    >
                      <EastIcon style={{ padding: "5px" }} />
                    </IconButton>
                  </InputAdornment>
                }
              />
            </FormControl>
            <Box
              display={"flex"}
              width={isMobileview ? "55%" : "80%"}
              alignItems={"center"}
              margin={"auto"}
              justifyContent={"space-around"}
              // border={'1px solid red'}
              gap={"5%"}
            ></Box>

            <Box sx={{ display: "flex", gap: "20px", margin: "auto" }}>
              <Button
                variant="contained"
                onClick={() => {
                  handleSubscribe();
                }}
              >
                Submit{" "}
              </Button>
            </Box>
          </Box>
        </Modal>
      </div>
    </>
  );
};

export default HomePage;
